import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import './QuoteFor.scss';

export default function QuoteFor(props) {
  return (
    <div className="quote-for w-100" >
      <h3 className='px-4'>
        <strong>
          <NumberFormat value={props.coverageAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </strong>
        &nbsp;{props.separator && '- '} Asset Based LTC
      </h3>
    </div>
  );
}

QuoteFor.propTypes = {
  coverageAmount: PropTypes.number.isRequired,
  separator: PropTypes.bool,
};




// WEBPACK FOOTER //
// ./src/components/Product/ABLTC/RequestIllustration/SubComponents/QuoteFor.js